<div class="pt-3" style="width:100%; padding-right:0px">
    <div class="main">
        <div class="header">
             <!-- Menu button enables for small screen (mobile) -->
             <div class="me-4 d-block d-md-none">
                <i class="fa fa-bars" (click)="showSideBarMenu()" style="font-size: 28px;" aria-hidden="true"></i>
            </div>
            
            <div class="iconContainer">
                <i class="fa fa-arrow-left" (click)="backIconClick()" style="cursor: pointer;"></i>
            </div>
            <div style="margin-left:20px; font-size: 20px; font-weight:600;">
                {{facilityInfo?.facility_name}}
            </div>
        </div>

        <div class="row contentContainer" style="padding-left:20px; height: 80vh;">
            <div class="col-3">
                <app-facility-info-left-panel [facilityInfo]="facilityInfo" (isDisableForm)="isDisableFormRes($event)"></app-facility-info-left-panel>
            </div>
            <div class="col-9" style="overflow-y: scroll; height:100%;">
                <app-reg-common-form [inputDataList]="inputDataList" [heading]="heading"
                (formButtonResEvent)="formButtonResEvent($event)" submitBtnText="UPDATE"
                showDraftBtn='false' formName="detailedRegister"
                [isDisableForm]="isDisableForm">
            </app-reg-common-form>
            </div>
        </div>
    </div>
</div>